// extracted by mini-css-extract-plugin
export default {"modalBody":"ModalBody_modalBody__tqLzy","centered":"ModalBody_centered__4uJmu"};